import React, { useState, useEffect } from "react";
import FormInputStyle4 from "../../UIElements/FormInput";
import FormSelectStyle4 from "../../UIElements/FormSelect";
import FormButtonStyle4 from "../../UIElements/FormButton";
import callApi from "../../../../utility/apiCaller";
import { setUserClickData } from "../../../../utility/setUserClickData";
import { toast } from "react-toastify";
import getStateFromPincode from "../../Utils/stateMapperfnction";
import { getAllianceLeadFromMoneyTapInput } from "../../../../utility/commonUtils";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { setInternalLead } from "../../../../store/app/aaSlice";
import useAddLead from "../../hooks/addLeadtoCRM";
import useUserEvent from "../../../../hooks/setUserclickhook";
import StickyCtaBar from "../../UIElements/StickyCtaBar";

function PersonalDetailsForm({
  isFormStarted,
  setIsFormStarted,
  currentStep,
  setCurrentStep,
  setMobileForOTP,
  formData,
  setFormData,
}) {
  const [gender, setGender] = useState("");
  const [fullName, setFullName] = useState("");
  //const [name, setName] = useState("");
  const [errors, setErrors] = useState({});
  const [dob, setDob] = useState(null);
  const [mobile, setMobile] = useState("");
  const [isMobileValid, setIsMobileValid] = useState(true);
  const [email, setEmail] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [pancard, setPan] = useState("");
  const [isPanValid, setIsPanValid] = useState(true);
  const [pincode, setPincode] = useState("");
  const [professionType, setprofessionType] = useState("");
  const [showErrors, setShowErrors] = useState(false);
  const [checked, setChecked] = useState(true);
  const [isFormValid, setIsFormValid] = useState(false);
  const [isConsentChecked, setIsConsentChecked] = useState(false);
  const [pincodeValidation, setpincodeValidation] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector((state) => state.app.user);
  const [params] = useSearchParams();
  const dispatch = useDispatch();
  const aaSlice = useSelector((state) => state?.aa);
  const InternalLeadId = aaSlice?.internalLeadId;
  const addLead = useAddLead();
  const [searchParams] = useSearchParams();

  const a = Number(params.get("a"));

  const { trackUserEvent } = useUserEvent();

  const handleMobileChange = (event) => {
    let value = event.target.value;

    // Remove any non-digit characters
    value = value.replace(/\D/g, "");

    // Limit to 10 digits
    if (value.length > 10) {
      value = value.slice(0, 10);
    }

    // Allow only if first digit is 6, 7, 8, or 9 (if length >= 1)
    if (value.length === 0 || /^[6-9]/.test(value)) {
      setMobile(value);
      setFormData((prev) => ({
        ...prev,
        mobile: value,
      }));
      setMobileForOTP(value);

      // Validate: length must be exactly 10 and no digit repeats more than 8 times consecutively
      const hasInvalidRepetition = /(.)\1{8,}/.test(value); // matches any digit repeated 9 or more times

      setIsMobileValid(value.length === 10 && !hasInvalidRepetition);
    }
  };

  useEffect(() => {
    if (!formData) return;

    //setName(formData.name || "");
    setMobile(formData.mobile || "");
    setFullName(formData.fullName || formData.name || "");
    setEmail(formData.email || "");
    setGender((formData.gender || "").toLowerCase());
    setPan(formData.pancard || "");
    setPincode(formData.pincode || "");
    setprofessionType(formData.professionType || "");
    setDob(toDobDisplay(formData.dob) || null);

    // Optional validation setters
  }, []);

  const formatDobDisplay = (raw) => {
    const d = String(raw || "").replace(/\D/g, "").slice(0, 8);
    if (d.length <= 2) return d;
    if (d.length <= 4) return `${d.slice(0, 2)} ${d.slice(2)}`;
    return `${d.slice(0, 2)} ${d.slice(2, 4)} ${d.slice(4)}`;
  };

  // Parse ISO / "DD MM YYYY" / digits into a real Date (null if invalid).
  const parseDob = (val) => {
    if (!val) return null;
    let dd, mm, yyyy;
    const iso = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(val));
    if (iso) {
      yyyy = +iso[1]; mm = +iso[2]; dd = +iso[3];
    } else {
      const d = String(val).replace(/\D/g, "");
      if (d.length !== 8) return null;
      dd = +d.slice(0, 2); mm = +d.slice(2, 4); yyyy = +d.slice(4, 8);
    }
    if (mm < 1 || mm > 12 || dd < 1 || dd > 31) return null;
    const date = new Date(yyyy, mm - 1, dd);
    // reject rollovers like 31/02/2000
    if (date.getFullYear() !== yyyy || date.getMonth() !== mm - 1 || date.getDate() !== dd)
      return null;
    return date;
  };

  const pad2 = (n) => String(n).padStart(2, "0");

  // Normalize any stored value to the "DD MM YYYY" display format.
  const toDobDisplay = (val) => {
    if (!val) return "";
    if (/^\d{4}-\d{2}-\d{2}$/.test(String(val))) {
      const d = parseDob(val);
      return d ? `${pad2(d.getDate())} ${pad2(d.getMonth() + 1)} ${d.getFullYear()}` : "";
    }
    return formatDobDisplay(val);
  };

  // Validate: returns an error string, or "" if the DOB is acceptable.
  const validateDob = (val) => {
    const digits = String(val || "").replace(/\D/g, "");
    if (digits.length !== 8) return "Enter your date of birth as DD MM YYYY";
    const d = parseDob(val);
    if (!d) return "Please enter a valid date";
    const today = new Date(); today.setHours(0, 0, 0, 0);
    const min = new Date(1950, 0, 1);
    const eighteen = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
    if (d < min) return "Date cannot be less than 1st Jan 1950";
    if (d > today) return "Date of birth cannot be in the future";
    if (d > eighteen) return "You must be at least 18 years old";
    return "";
  };

  // "DD MM YYYY" / digits -> ISO "YYYY-MM-DD" for the API (matches DMI).
  const dobToIso = (val) => {
    const d = parseDob(val);
    return d ? `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}` : val;
  };

  const handleEmailChange = (event) => {
    const value = event.target.value.trim();

    setEmail(value);
    setFormData((prev) => ({
      ...prev,
      email: value,
    }));

    // Always validate live
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setIsEmailValid(emailRegex.test(value));
  };

  const handlePanChange = (e) => {
    const value = e.target.value.toUpperCase();
    setPan(value);

    // Always validate live
    const isValid = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value);
    setIsPanValid(isValid && value.length === 10); // only invalid if length = 10 & pattern fails
  };

  const handlePincodeChange = async (value) => {
    value = value.replace(/\D/g, ""); // allow only digits

    if (/^\d{0,6}$/.test(value)) {
      // Prevent first digit being 0 if there's at least one digit
      if (value.length > 0 && value[0] === "0") {
        return; // ignore input if first digit is 0
      }

      setPincode(value); // always update input field

      // clear error if user is still typing
      if (errors.pincode) {
        setErrors((prev) => ({ ...prev, pincode: false }));
      }

      // Only validate when user has entered 6 digits
      if (value.length === 6) {
        setpincodeValidation(true); // start loading state

        try {
          // ✅ call your backend API using callApi instead of fetch
          const response = await callApi(
            `v1/util/${value}`, // backend route
            "get", // HTTP method
            {}, // body (not needed for GET)
            "core" // service key
          );

          if (!response.success) {
            setErrors((prev) => ({ ...prev, pincode: true }));
          } else {
            setErrors((prev) => ({ ...prev, pincode: false }));
            setFormData((prev) => ({
              ...prev,
              city: response.city,
              state: getStateFromPincode(value),
            }));

            console.log("Valid Pincode, City:", response.city);
          }
        } catch (error) {
          console.error("Pincode validation error:", error);
          setErrors((prev) => ({ ...prev, pincode: true }));
        } finally {
          setpincodeValidation(false); // end loading state
        }
      }
    }
  };

  const handleProfessionChnage = (value) => {
    //console.log(value);
    setprofessionType(value);
    if (errors.professionType) {
      setErrors((prev) => ({ ...prev, professionType: false }));
    }
  };

  // const handleNameChange = (e) => {
  //   let newName = e.target.value;

  //   // Remove any character that is not a letter or space
  //   newName = newName.replace(/[^A-Za-z\s]/g, "");

  //   // Replace multiple spaces with a single space
  //   newName = newName.replace(/\s+/g, " ");

  //   setName(newName);

  //   // Validate: name must have at least 2 characters after trimming
  //   setErrors((prev) => ({
  //     ...prev,
  //     name: newName.trim().length < 2,
  //   }));
  // };

  //console.log("Personal formData:", formData);

  useEffect(() => {
    const allValid =
      gender &&
      //name.trim() &&
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) &&
      (!errors.email || errors.email === false) &&
      /^\d{6}$/.test(pincode) &&
      (!errors.pincode || errors.pincode === false || pincodeValidation) &&
      professionType &&
      (!errors.professionType || errors.professionType === false) &&
      pancard &&
      (!errors.pan || errors.pan === false) &&
      isPanValid &&
      isConsentChecked &&
      dob &&
      (!errors.dob || errors.dob === false);

    setIsFormValid(allValid);
  }, [
    gender,
    //name,
    email,
    errors.email,
    dob,
    errors.dob,
    pincode,
    errors.pincode,
    professionType,
    errors.professionType,
    pancard,
    errors.pan,
    isPanValid,
    isConsentChecked,
  ]);

  useEffect(() => {
    if (formData) {
      setGender((formData.gender || "").toLowerCase());
      //setName(formData.name || "");
      setMobile(formData.mobile || "");
      setPan(formData.pancard || "");
      setEmail(formData.email || "");
      setPincode(formData.pincode || "");
      setprofessionType(formData.professionType || "");
      setDob(toDobDisplay(formData.dob) || null);
      setIsConsentChecked(formData.mobiletncchecked || false);
      // setFormData((prev) => ({
      //   ...prev,
      // setIpAddress(ipAddress);
    }
  }, []);

  let allianceId = "multistep-pl-ete-lead";

  if (a == 2) {
    allianceId = "zv2";
  } else if (a == 3) {
    allianceId = "zv3";
  } else if (a == 4) {
    allianceId = "zv4";
  }

  const handleConsentChange = async () => {
    setIsConsentChecked((prev) => {
      const newValue = !prev;
      //console.log("Old:", prev, "New:", newValue);
      return newValue;
    });
  };
  const handleValidateAndSendOtp = async () => {
    // Step 1: Validate form
    if (!handleValidation()) {
      return;
    }

    // Step 2: Check consent
    if (!isConsentChecked) {
      toast.error("Please agree to the Terms and Conditions.");
      return;
    }

    setUserClickData({
      event_name: `personal-details-multistep-pl-v1`,
      user_id: mobile || formData?.mobile || "unknown",
      affiliate_id: params.get("aff_id") || "No Aff_id found",
      utm_source: params.get("utm_source") || params.get("utm_medium"),
      utm_term: params.get("utm_term"),
    });

    try {
      setIsLoading(true);

      // Step 3: Call API to send OTP

      // Step 4: Handle API response

      //  affId ||

      // Step 5: Update form data only after OTP sent
      setFormData((prev) => ({
        ...prev,
        gender,
        pancard,
        //name,
        email,
        pincode,
        professionType,
        mobile,
        dob,
        mobiletncchecked: true,
        mobiletnctime: new Date().toISOString(),
      }));

      const trackId = localStorage.getItem("track_id");

      const url = InternalLeadId
        ? `v1/lead/${InternalLeadId}/update-lead-new`
        : "v1/lead/dmi-lead";

      const res = await callApi(
        url,
        "post",
        {
          lead: {
            tracking_id: trackId,
            contact_phone: mobile,
            contact_email: email,
            contact_name: fullName,
            dob: dobToIso(dob),
            gender: gender,
            pincode,
            city: formData.city,
            state: formData.state,
            pancard: pancard,
            profession_type: professionType,
            address1: formData.prefillAddress?.full || "NA",
            ip_address: formData.ip_address || "",
            steps_completed: 2,
            alliance_id: allianceId,
            aff_id: params.get("aff_id"),
            utm_source: params.get("utm_source")?.split("?")[0],
            source: params.get("source"),
            utm_medium: params.get("utm_medium"),
            utm_term: params.get("utm_term"),
            ads_name: params.get("ads_name"),
          },
        },
        "core",
        user?.token ||
          "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2OTMxNTQ2NDEwYjdkNTgzMDA3NjIyYmEiLCJvdHAiOiIxMTExIiwiY29udGFjdF9waG9uZSI6Ijk5MjIxODcwMDUiLCJvdHBfZXhwaXJ5IjoiMjAyNS0xMi0wNFQwOTozOTowOC42NjhaIiwiaWF0IjoxNzY0ODQwNTU0fQ.ksMJv8yeMuVZvk6EtBuajtH1-CuCvtvFmv2X-1Ab71Y"
      );
      await callApi(
        `v1/lead/customer-check-e2e`,
        "post",
        {
          lead: {
            tracking_id: trackId,
            contact_phone: mobile,
            contact_email: email,
            contact_name: fullName,
            dob: dobToIso(dob),
            gender: gender,
            pincode,
            city: formData.city,
            state: formData.state,
            pancard: pancard,
            profession_type: professionType,
            address1: formData.prefillAddress?.full || "NA",
            ip_address: formData.ip_address || "",
            steps_completed: 2,
            alliance_id: allianceId,
            aff_id: params.get("aff_id"),
            utm_source: params.get("utm_source")?.split("?")[0],
            source: params.get("source"),
            utm_medium: params.get("utm_medium"),
            utm_term: params.get("utm_term"),
            ads_name: params.get("ads_name"),
          },
        },
        "core",
        user?.token ||
          "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2OTMxNTQ2NDEwYjdkNTgzMDA3NjIyYmEiLCJvdHAiOiIxMTExIiwiY29udGFjdF9waG9uZSI6Ijk5MjIxODcwMDUiLCJvdHBfZXhwaXJ5IjoiMjAyNS0xMi0wNFQwOTozOTowOC42NjhaIiwiaWF0IjoxNzY0ODQwNTU0fQ.ksMJv8yeMuVZvk6EtBuajtH1-CuCvtvFmv2X-1Ab71Y"
      );
      const finalLeadId = InternalLeadId || res?.data?.lead?._id;
      if (!InternalLeadId) {
        dispatch(setInternalLead(finalLeadId));
      }
      // toast.success("OTP Sent Successfully");

      // Call useAddLead hook on successful submission
      if (finalLeadId) {
        try {
          await addLead({
            leadId: finalLeadId,
            lead_type: "live",
            priority: 3,
            stage: "Personal Details",
          });
        } catch (error) {
          console.error("Error adding lead to CRM:", error);
        }
      }

      setIsFormStarted(true);

      // Step 6: Move to Loan Amount step (v17 inserts this between Personal & Professional)
      setCurrentStep(3);
    } catch (error) {
      // toast.error("An error occurred while sending OTP.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    //console.log("Consent checked updated:", isConsentChecked);
  }, [isConsentChecked]);

  const handleValidation = () => {
    setShowErrors(true); // enables red borders

    const newErrors = {};

    if (!gender) newErrors.gender = true;
    const dobErr = validateDob(dob);
    if (dobErr) newErrors.dob = dobErr;
    //if (!name.trim()) newErrors.name = true;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = true;
      setIsEmailValid(false);
    }
    if (!pincode.match(/^\d{6}$/)) newErrors.pincode = true;
    if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pancard)) {
      newErrors.pancard = true;
      setIsPanValid(false);
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  return (
    <>
    <div className="dm-verify-v9 w-full max-w-[400px] mx-auto bg-white px-4 pb-[120px] flex flex-col font-atkinson">
      {/* Progress (2/4) */}
      <div className="flex items-center gap-[14px] pt-2 pb-1">
        <button
          type="button"
          onClick={() => setCurrentStep && setCurrentStep(currentStep - 1)}
          aria-label="Go back"
          className="w-6 h-6 flex-none flex items-center justify-center"
        >
          <img src={process.env.PUBLIC_URL + "/assets/icons/left_arrow.png"} alt="" className="w-5 h-5 object-contain" />
        </button>
        <div className="flex-1 h-[7px] rounded-[6px] bg-[#c9f7e0] overflow-hidden">
          <div className="h-full bg-[#12f280] rounded-[6px]" style={{ width: "42%" }} />
        </div>
        <span className="text-[15px] text-[#3a3a3a] flex-none">2/4</span>
      </div>

      <h1 className="font-bold text-[20px] leading-[1.15] tracking-[-0.01em] mt-4 text-[#1b1b1b]">
        We found your details—please check them
      </h1>
      <p className="text-[14px] text-[#8b8b8b] mt-2">Correct anything that looks wrong.</p>

      {/* Gender */}
      <div className="font-semibold text-[15px] text-[#3a3a3a] mt-4 pl-6">Select your Gender</div>
      <div className="flex gap-[10px] mt-3">
        {["Male", "Female", "Other"].map((label) => {
          const value = label.toLowerCase(); // stored value is always lowercase: "male" | "female" | "other"
          const cur = (gender || "").trim().toLowerCase();
          const isMale = cur === "male" || cur === "m";
          const isFemale = cur === "female" || cur === "f";
          const selected =
            (value === "male" && isMale) ||
            (value === "female" && isFemale) ||
            (value === "other" && cur !== "" && !isMale && !isFemale);
          return (
            <button
              key={value}
              type="button"
              onClick={() => {
                setGender(value);
                setFormData((prev) => ({ ...prev, gender: value }));
              }}
              className={
                "h-[39px] px-6 flex items-center justify-center rounded-full text-[16px] border-[1.5px] transition-colors " +
                (selected
                  ? "bg-black text-white border-black"
                  : "bg-white text-[#3a3a3a] border-[#e6e6e6]")
              }
            >
              {label}
            </button>
          );
        })}
      </div>

      {/* Full Name */}
      <div className="w-full h-[72px] flex flex-col justify-center border border-[#e6e6e6] rounded-[15px] px-4 mt-3">
        <div className="text-[12px] text-[#5f6066]">Full Name</div>
        <input
          value={fullName}
          onChange={(e) => {
            setFullName(e.target.value);
            setFormData((prev) => ({ ...prev, fullName: e.target.value }));
          }}
          placeholder="Full name as per PAN"
          className="w-full bg-transparent outline-none text-[16px] text-[#1b1b1b] mt-[2px] placeholder:text-[#b3b3b3]"
        />
      </div>

      {/* Date of Birth */}
      <div className="relative w-full h-[72px] flex flex-col justify-center border border-[#e6e6e6] rounded-[15px] px-4 mt-3">
        <div className="text-[12px] text-[#5f6066]">Date of Birth</div>
        <input
          value={dob || ""}
          onChange={(e) => {
            const formatted = formatDobDisplay(e.target.value);
            setDob(formatted);
            setFormData((prev) => ({ ...prev, dob: formatted }));
            const complete = formatted.replace(/\D/g, "").length === 8;
            setErrors((prev) => {
              const { dob: _omit, ...rest } = prev;
              if (complete) {
                const err = validateDob(formatted);
                return err ? { ...rest, dob: err } : rest;
              }
              return rest; // don't nag while still typing
            });
          }}
          placeholder="DD MM YYYY"
          inputMode="numeric"
          className="w-full bg-transparent outline-none text-[16px] text-[#1b1b1b] mt-[2px] pr-8 placeholder:text-[#b3b3b3]"
        />
        {/* calendar icon opens the native date picker (fills DD MM YYYY) */}
        <label className="absolute right-4 top-1/2 -translate-y-1/2 w-[22px] h-[22px] cursor-pointer">
          <svg className="pointer-events-none" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#12f280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="5" width="18" height="16" rx="3" />
            <path d="M3 9h18M8 3v4M16 3v4" />
          </svg>
          <input
            type="date"
            max={new Date().toISOString().split("T")[0]}
            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
            onClick={(e) => { if (e.target.showPicker) e.target.showPicker(); }}
            onChange={(e) => {
              const iso = e.target.value; // YYYY-MM-DD
              if (!iso) return;
              const [y, m, d] = iso.split("-");
              const display = `${d} ${m} ${y}`;
              setDob(display);
              setFormData((prev) => ({ ...prev, dob: display }));
              const err = validateDob(display);
              setErrors((prev) => {
                const { dob: _omit, ...rest } = prev;
                return err ? { ...rest, dob: err } : rest;
              });
            }}
          />
        </label>
      </div>
      <p className="text-[12px] text-[#b3b3b3] mt-1.5 pl-4">
        Enter your date of birth as DD MM YYYY
      </p>
      {errors.dob && typeof errors.dob === "string" && (
        <p className="text-[12px] text-red-500 mt-1 ml-1">{errors.dob}</p>
      )}

      {/* PAN */}
      <div className="w-full h-[72px] flex flex-col justify-center border border-[#e6e6e6] rounded-[15px] px-4 mt-3">
        <div className="text-[12px] text-[#5f6066]">Pan Card Number</div>
        <input
          value={pancard}
          onChange={handlePanChange}
          maxLength={10}
          placeholder="ABCDE1234F"
          className="w-full bg-transparent outline-none text-[16px] text-[#1b1b1b] mt-[2px] placeholder:text-[#b3b3b3] uppercase"
        />
      </div>
      {!isPanValid && (
        <p className="text-[12px] text-red-500 mt-1 ml-1">Please enter a valid PAN Number</p>
      )}

      {/* Email */}
      <div className="w-full h-[72px] flex flex-col justify-center border border-[#e6e6e6] rounded-[15px] px-4 mt-3">
        <div className="text-[12px] text-[#5f6066]">Personal Email Address</div>
        <input
          value={email}
          onChange={handleEmailChange}
          placeholder="name@email.com"
          className="w-full bg-transparent outline-none text-[16px] text-[#1b1b1b] mt-[2px] placeholder:text-[#b3b3b3]"
        />
      </div>
      {!isEmailValid && <p className="text-[12px] text-red-500 mt-1 ml-1">Enter a valid email</p>}

      {/* Pincode */}
      <div className="relative w-full h-[72px] flex flex-col justify-center border border-[#e6e6e6] rounded-[15px] px-4 mt-3">
        <div className="text-[12px] text-[#5f6066]">Home Pin Code</div>
        <input
          value={pincode}
          onChange={(e) => handlePincodeChange(e.target.value)}
          onBlur={() => {
            if (!/^\d{6}$/.test(pincode) || errors.pincode) {
              setErrors((prev) => ({ ...prev, pincode: true }));
            }
          }}
          inputMode="numeric"
          maxLength={6}
          autoComplete="off"
          placeholder="400001"
          className="w-full bg-transparent outline-none text-[16px] text-[#1b1b1b] mt-[2px] pr-8 placeholder:text-[#b3b3b3]"
        />
        {pincodeValidation ? (
          <span className="absolute right-4 top-1/2 -translate-y-1/2 w-5 h-5 border-2 border-[#c9f7e0] border-t-[#12f280] rounded-full animate-spin" />
        ) : (
          pincode.length === 6 && !errors.pincode && (
            <img
              src={process.env.PUBLIC_URL + "/assets/img/checked.svg"}
              alt=""
              aria-hidden="true"
              className="absolute right-4 top-1/2 -translate-y-1/2 w-[22px] h-[22px] object-contain"
            />
          )
        )}
      </div>
      {errors.pincode && (
        <p className="text-[12px] text-red-500 mt-1 ml-1">Enter a valid 6-digit PIN</p>
      )}

      <div className="flex-1 min-h-[16px]" />
    </div>
    <StickyCtaBar>
      <p className="text-[12px] text-[#9a9a9a] italic text-left mb-2">
        Need to update something? Tap the field to edit.
      </p>
      <button
        type="button"
        onClick={handleValidateAndSendOtp}
        disabled={isLoading || pincodeValidation}
        id="personal-submit-v17"
        className="w-full bg-black text-white font-bold text-[18px] rounded-[16px] py-[17px] active:scale-[0.99] transition-transform disabled:opacity-50"
      >
        Looks right, continue
      </button>
    </StickyCtaBar>
    </>
  );
}

export default PersonalDetailsForm;